<script>
import UploadPopover from "@/components/widgets/upload-popover.vue";
import RawData from "@/components/widgets/raw-data.vue";
import { groupBy } from 'lodash';

export default {
    components: {
        UploadPopover,
        RawData
    },
    props: {
        department: Boolean,
        opcrType: {
            type: String,
            default: 'planning'
        },
        proposal: Boolean,
        selectedTransfer: Object,
        selectedOPCR: Object,
        startTranferApiToOPCR: Boolean,
        itemList: Array,
        opcrs: Array,
        targetData: Array,
        loadOpcrs: Boolean,
        selectAllAPI: Boolean,
        tableBusy: Boolean,
        startSelection: Boolean,
        apiName: String,
        loadItems: Boolean,
        selectedTarget: Object,
        selectedItem: [Number, String],
        selectedTemplate: null,
    },
    data(){
        return {
            searchOPCR: '',
            pageOptions: [5, 10, 25, 50, 100],
            perPage: 5,
            perPageItem: 1,
            totalRows: 1,
            currentPage: 1,
            currentPageItem: 1,
            filter: null,
            showTarget: false,
            showOPCR: false,
            filterOn: ['name'],
            sortBy: "name",
            sortDesc: false,
            filterIndicatorItem: "",
            isNGO: window.IS_SCHOOL ? false : true
        }
    },
    computed: {
        returnFields(){
            if(this.opcrType === 'planning'){
                return [
                    {
                        key: "name",
                        label: "Activity Program Initiative Name",
                        sortable: true,
                    },
                    {
                        key: "totalResources",
                        sortable: true,
                        label: "Total Resources",
                        thStyle: { width: "200px" },
                    },
                    {
                        key: "actions",
                        thStyle: { width: "90px" },
                    },
                ]
            }else{
                return [
                    {
                        key: "name",
                        label: "API Name",
                        sortable: true,
                    },
                    {
                        key: "totalCurrency",
                        sortable: true,
                        label: "Total Resources",
                        thStyle: { width: "180px" },
                    },
                    {
                        key: "score",
                        sortable: true,
                        thStyle: { width: "150px" },
                    },

                    {
                        key: "status",
                        sortable: true,
                        thStyle: { width: "200px" },
                    },
                    {
                        key: "actions",
                        thStyle: { width: "90px" },
                    },
                ]
            }
        },
        canCreateOPCR(){
            if(this.opcrType === 'planning' && !this.startTranferApiToOPCR && this.selectedTransfer && !this.selectedTransfer.id && !this.proposal){
                return true;
            }
            if(this.proposal && this.selectedTemplate && this.selectedTemplate.id){
                return true;
            }
            return false;
        },
        rows() {
            if (this.filter) {
                return this.totalRows;
            }
            return this.targetData.length;
        },
        filteredOPCRs() {
            let data = this.opcrs;
            if (this.searchOPCR.trim() != "" && this.searchOPCR) {
                data = data.filter((item) => {
                    return item.title
                        .toUpperCase()
                        .includes(this.searchOPCR.toUpperCase());
                });
            }
            return data;
        },
        filteredApis() {
            let data = this.targetData;
            if (this.filter && this.filter.trim() != "") {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            var groupedClass = groupBy(data, "type");
            var classID = 1;
            var grouped = [];
            for (const key in groupedClass) {
                grouped.push({
                    id: classID++,
                    data: groupedClass[key],
                    key: key,
                });
            }
            return grouped;
        },
        filteredItems() {
            let data = this.itemList;
            if (this.filterIndicatorItem.trim() != "" && this.filterIndicatorItem) {
                data = data.filter((item) => {
                    return item.searchList
                        .toUpperCase()
                        .includes(this.filterIndicatorItem.toUpperCase());
                });
            }
            var grouped = [];
            if(this.opcrType === 'planning'){
                var groupedClass = groupBy(data, "classification");
                var classID = 1;
                for (const key in groupedClass) {
                    grouped.push({
                        id: classID++,
                        data: groupedClass[key],
                        key: key,
                    });
                }
                return grouped;
            }else{
                var groupedPrexC = groupBy(data, "prexC");
                var PrexcID = 1;
                var iiID = 1;
                for (const key in groupedPrexC) {
                    var group = groupBy(groupedPrexC[key], "indicatorItem");
                    var FC = [];
                    for (const y in group) {
                        FC.push({
                            id: iiID++,
                            data: group[y],
                            key: y,
                        });
                    }
                    grouped.push({
                        id: PrexcID++,
                        data: FC,
                        key: key,
                    });
                }
                var total = this.currentPageItem * this.perPageItem;
                var currentData = grouped.slice(total - this.perPageItem, total);
                return currentData;
            }
        },
        rowsItems() {
            let data = this.itemList;
            if (this.filterIndicatorItem.trim() != "" && this.filterIndicatorItem) {
                data = data.filter((item) => {
                    return item.searchList
                        .toUpperCase()
                        .includes(this.filterIndicatorItem.toUpperCase());
                });
            }
            var groupedPrexC = groupBy(data, "prexC");
            var PrexcID = 1;
            var iiID = 1;
            var grouped = [];
            for (const key in groupedPrexC) {
                var group = groupBy(groupedPrexC[key], "indicatorItem");
                var FC = [];
                for (const y in group) {
                    FC.push({
                        id: iiID++,
                        data: group[y],
                        key: y,
                    });
                }
                grouped.push({
                    id: PrexcID++,
                    data: FC,
                    key: key,
                });
            }
            return grouped.length;
        },
        
        selectedApiComputed() {
            if(this.selectAllAPI){
                let data = [];
                this.targetData.map(item => {
                    item.planningApis.map(x => {
                        if(x.selected){
                            data.push(x);
                        }
                    })
                })
                return data;
            }else{
                return this.targetData.filter((item) => {
                    return item.selected;
                });
            }
        },
        checkAll: {
            get(){
                if(this.selectAllAPI){
                    return this.targetData.every((item) => {
                        return item.planningApis.every(x => {
                            return x.selected;
                        })
                    });
                }else{
                    return this.targetData.every((item) => {
                        return item.selected;
                    });
                }
               
            },
            set(newValue){
                this.targetData.forEach((item) => {
                    item.selected = newValue;
                });
            }
        },
        nameSelection(){
            if(this.department){
                return 'DPCR';
            }
            return 'OPCR';
        },
        officeTypeName(){
            if(this.proposal) return 'Proposal';
            return this.$store.state.data.selectedCampus.isExternal ? 'WFP' : `${this.nameSelection}`;
        }
    },
    methods: {
        createNewOPCR(){
            this.$emit('createNewOPCR');
        },
        getAllAPI(){
            this.$emit('getAllAPI');
        },
        closeOPCRPopover(){
            this.showOPCR = false;
            this.$emit('closeOPCRPopover');
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        selectOPCR(opcr){
            this.showOPCR = false;
            this.$emit('selectOPCR', opcr);
        },
        closeTargetPopOver(){
            this.showTarget = false;
            this.$emit('closeTargetPopOver');
        },
        selectIndicatorItem(indicator){
            this.$emit('selectIndicatorItem', indicator);
        },
        filterApiCards(apis){
            let data = apis;
            if(this.filter && this.filter.trim !== ''){
                data = data.filter(x => {
                    return x.filterKey.toUpperCase().includes(this.filter.toUpperCase());
                })
            }
            return data;
        },
        openSelectionOfApi(){
            this.$emit('openSelectionOfApi')
        },
        goToPPMP(row){
            this.$emit('goToPPMP', row);
        },
        goToPPMPAll(row, parent){
            this.$emit('goToPPMPAll', {row, parent});
        },
        printPPMP(row){
            this.$emit('printPPMP', row);
        },
        postOPCR(){
            this.$emit('postOPCR');
        },
        addApi(target){
            this.$emit('addApi', target);
        },
        deleteItem(row){
            this.$emit('deleteItem', row);
        },
        deleteItemAll(row, parent){
            this.$emit('deleteItemAll', {row, parent});
        },
        updateItemAll(row, parent){
            this.$emit('updateItemAll', {row, parent});
        },
        updateItem(row){
            this.$emit('updateItem', row);
        },
        deleteOPCR(row){
            this.$emit('deleteOPCR', row);
        },
        updateOPCR(row){
            this.$emit('updateOPCR', row);
        },
        transferApiToOPCR(){
            this.$emit('transferApiToOPCR');
        },
        transferApiToKPI(){
            this.$emit('transferApiToKPI');
        },
        showImportApis(){
            this.$emit('showImportApis');
        },
        printDULIB(){
            this.$emit('printDULIB');
        },
        printPPMPByApi(id, type){
            this.$emit('printPPMPByApi', {id, type});
        },
        printIndicativePR(id){
            this.$emit('printIndicativePR', id);
        },
        printWFP(){
            this.$emit('printWFP');
        },
        printOPCR(type){
            this.$emit('printOPCR', type);
        },
        searchDocu(row) {
            let data = row.attachments;
            if (row.fileSearch.trim() != "" && row.fileSearch) {
                data = data.filter((item) => {
                    return item.description
                        .toUpperCase()
                        .includes(row.fileSearch.toUpperCase());
                });
            }
            return data;
        },
        uploadedDocument(response, id) {
            this.$emit('uploadedDocument', {response, id})
        },
        determineApis(opcr){
            if(this.opcrType === 'planning'){
                return opcr.planningApis;
            }else{
                return opcr.apis;
            }
        },
        transferApiIfs(row){
            if(this.opcrType === 'planning'){
                if(this.selectedTransfer.planningApiId == row.id || this.selectedTransfer.departmentPlanningApiId == row.id){
                    return false;
                }
                return true;
            }else{
                if(this.selectedTransfer.apiId == row.id){
                    return false;
                }
                if((row.status.toUpperCase() === "APPROVED" || row.status.toUpperCase() === "POSTED") && !this.$store.state.decrypt.isAdmin()){
                    return false;
                }
                return true;
            }
        },
        viewOPCRLogs(id){
            this.$emit('viewOPCRLogs', id);
        },
        selectTransferApi(row, parent){
            this.$emit('selectTransferApi', {row, parent})
        },
        showApiAttachments(api){
            this.$emit('showApiAttachments', api)
        }
    }
}
</script>
<template>
    
    <b-row>
        <b-col sm="3">
            <slot name="proposal-opts"></slot>
            <div class="d-flex align-items-center justify-content-between" :class="{'mb-3': canCreateOPCR || opcrType == 'actual'}">
                <div>
                    <b-dropdown
                        id="dropdown-dropleft"
                        right
                        variant="purple btn-sm"
                        toggle-class="text-decoration-none"
                        menu-class="dropdown-menu"
                        no-caret
                        v-if="canCreateOPCR && !department"
                    >
                        <template #button-content>
                            <i class="bx bx-printer me-1"></i>
                            Reports
                        </template>
                        <template v-if="opcrType === 'planning'">
                            <b-dropdown-item
                                @click="printWFP"
                                v-if="selectedOPCR && $store.state.data.selectedCampus.isExternal"
                            >
                                WFP
                            </b-dropdown-item>
                            <b-dropdown-item
                                @click="printOPCR"
                                v-if="selectedOPCR && !$store.state.data.selectedCampus.isExternal"
                                >{{nameSelection}}</b-dropdown-item
                            >
                            <b-dropdown-item
                                @click="printOPCR(3)"
                                v-if="selectedOPCR && !$store.state.data.selectedCampus.isExternal && $store.state.decrypt.isAdmin() && !isNGO"
                                >{{nameSelection}} (v2)</b-dropdown-item
                            >
                            <b-dropdown-item
                                @click="printOPCR(4)"
                                v-if="selectedOPCR && !$store.state.data.selectedCampus.isExternal && $store.state.decrypt.isAdmin() && !isNGO"
                                >{{nameSelection}} (v3)</b-dropdown-item
                            >
                            <b-dropdown-item
                                @click="printDULIB"
                                v-if="selectedOPCR"
                                >LIB</b-dropdown-item
                            >
                            <b-dropdown-item
                                v-if="selectedOPCR"
                                @click="printPPMP(1)"
                                >PPMP</b-dropdown-item
                            >
                            <b-dropdown-item
                                v-if="selectedOPCR"
                                @click="printPPMP(2)"
                                >PPMP (v2)</b-dropdown-item
                            >
                        </template>
                        <template v-else>
                            <b-dropdown-item @click="printOPCR" v-if="!$store.state.data.selectedCampus.isExternal"
                                >{{nameSelection}}</b-dropdown-item
                            >
                            <b-dropdown-item @click="printWFP" v-if="$store.state.data.selectedCampus.isExternal"
                                >WFP</b-dropdown-item
                            >
                            <b-dropdown-item @click="printDULIB"
                                >LIB</b-dropdown-item
                            >
                            <b-dropdown-item @click="printPPMP"
                                >PPMP</b-dropdown-item
                            >
                            <b-dropdown-item
                                v-if="selectedOPCR"
                                @click="printPPMP(2)"
                                >PPMP (v2)</b-dropdown-item
                            >
                        </template>
                    </b-dropdown>
                    <b-dropdown
                        id="dropdown-dropleft"
                        right
                        variant="purple btn-sm"
                        toggle-class="text-decoration-none"
                        menu-class="dropdown-menu"
                        no-caret
                        v-if="opcrType == 'actual' && !department"
                    >
                        <template #button-content>
                            <i class="bx bx-printer me-1"></i>
                            Reports
                        </template>
                        <b-dropdown-item @click="printOPCR" v-if="!$store.state.data.selectedCampus.isExternal"
                            >{{nameSelection}}</b-dropdown-item
                        >
                        <b-dropdown-item @click="printOPCR(4)" v-if="!$store.state.data.selectedCampus.isExternal && $store.state.decrypt.isAdmin() && !isNGO"
                            >{{nameSelection}} (v3)</b-dropdown-item
                        >
                        <b-dropdown-item @click="printWFP" v-if="$store.state.data.selectedCampus.isExternal"
                            >WFP</b-dropdown-item
                        >
                        <b-dropdown-item @click="printDULIB"
                            >LIB</b-dropdown-item
                        >
                        <b-dropdown-item @click="printPPMP"
                            >PPMP</b-dropdown-item
                        >
                        <b-dropdown-item
                            v-if="selectedOPCR"
                            @click="printPPMP(2)"
                            >PPMP (v2)</b-dropdown-item
                        >
                    </b-dropdown>
                </div>
                <div v-if="canCreateOPCR">
                    <button
                        type="button"
                        class="btn btn-sm btn-primary"
                        @click="createNewOPCR"
                    >
                        <i class="bx bx-plus"></i> Create New {{officeTypeName}}
                    </button>
                </div>
            </div>
            <div>
                <div class="mb-4">
                    <div class="border-dashed-img position-relative p-5 text-center cursor-pointer"  :class="{'info selected': selectedOPCR}">
                        <h5 class="text-muted py-4" v-if="!selectedOPCR"> Click to Select/Add {{officeTypeName}} </h5>
                        <div v-else >
                            <h5 class="mb-0">{{selectedOPCR.title}}</h5>
                            <small v-if="selectedOPCR.isSupplemental" class="text-success font-weight-bold">Supplemental</small>
                        </div>
                        <span type="button" class="badge rounded-pill bg-secondary mt-2" @click="viewOPCRLogs(selectedOPCR.id)" v-if="opcrType === 'planning' && !department && selectedOPCR">View Logs</span>
                        <span v-if="selectedOPCR" class="position-absolute bg-body px-2 text-info border" style="left:10px;top:-8px;">Selected/Default {{officeTypeName}}</span>
                        <template v-if="opcrType === 'planning'">
                            <span v-if="selectedOPCR  && (selectedOPCR.status.toUpperCase().includes('POST') || selectedOPCR.status.toUpperCase().includes('APPROVE'))" class="position-absolute bg-body px-2 text-success font-weight-bold border" style="right:10px;top:-8px;">{{selectedOPCR.status}}</span>
                            <a href="javascript:void(0);" class="btn btn-success btn-sm position-absolute" style="right:0;top:-8px;"  @click="postOPCR" v-if="opcrType === 'planning' && !selectedTransfer.id && (selectedOPCR && (selectedOPCR.status.toUpperCase().includes('DRAFT') || selectedOPCR.status.toUpperCase().includes('RETURN')))"><i class="bx bx-check"></i> Post {{officeTypeName}}</a>
                        </template>
                        <a href="javascript:void(0);" v-if="!selectedTransfer.id" class="position-absolute text-dark font-size-16 hover-underline" style="right:10px;bottom:5px;" id="selectOPCR" @click="showOPCR = true"><i class="bx bx-list-ol"></i> View List</a>
                    </div>
                    <b-popover
                        :show.sync="showOPCR"
                        :target="`selectOPCR`"
                        :custom-class="`popoverOPCRClass`"
                        triggers="click"
                        placement="right"
                        id="opcrRef"
                    >
                        <template
                            v-slot:title
                        >
                            <div class="d-flex justify-content-between align-items-center">
                                <p class="m-0">Select {{officeTypeName}}</p>
                                <button
                                    type="button"
                                    class="btn btn-sm btn-danger"
                                    @click="closeOPCRPopover"
                                >
                                    <i class="bx bx-x"></i>
                                </button>
                            </div>
                        </template>
                        <div class="d-flex align-items-center justify-content-between mb-3">
                            <div>
                                <input type="text" class="form-control form-control-sm" v-model="searchOPCR" :placeholder="`Search ${officeTypeName}`" v-if="opcrs.length > 0">
                            </div>
                        </div>
                        <div v-if="loadOpcrs">
                            <div class="text-center">
                                <div class="spinner-border text-primary" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        </div>
                        <template v-if="!loadOpcrs && opcrs.length == 0">
                            <div class="text-center">
                                No data found...
                            </div>
                        </template>
                        <template v-if="!loadOpcrs && opcrs.length > 0 && filteredOPCRs.length == 0">
                            <div class="text-center">
                                Search not found...
                            </div>
                        </template>
                        <div class="scrollable-div pe-1">
                            <div v-for="opcr in filteredOPCRs" :key="opcr.id">
                                <div class="d-flex align-items-center justify-content-between border border-2 p-2 mb-2 position-relative">
                                    <RawData :data="opcr" v-if="$store.state.decrypt.isAdmin()"/>
                                    <div>
                                        <h5 class="mb-0 cursor-pointer" @click="selectOPCR(opcr)">{{ opcr.title }}</h5>
                                        <small class="text-success" v-if="opcr.isSupplemental">Supplemental</small>
                                    </div>
                                    <template v-if="opcrType === 'planning'">
                                        <div class="d-flex" v-if="(opcr.status.toUpperCase().includes('DRAFT') || opcr.status.toUpperCase().includes('RETURN')) && !startTranferApiToOPCR">
                                            <i class="bx bx-edit text-primary font-size-18 cursor-pointer" @click="updateOPCR(opcr)"></i>
                                            <i class="bx bx-trash text-danger font-size-18 cursor-pointer" @click="deleteOPCR(opcr)"></i>
                                        </div>
                                        <div v-else>
                                            <span class="badge rounded-pill bg-success font-size-12">Posted</span>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </b-popover>
                </div>
                <div class="mb-3" v-if="!department && selectedOPCR">
                    <div class="border-dashed-img position-relative p-5 text-center cursor-pointer" id="selectTarget" @click="showTarget = true" :class="{'selected info': selectedItem != 0 && !selectAllAPI}">
                        <h5 class="text-muted my-4" v-if="selectedItem == 0 || selectAllAPI"> Click to Select Target </h5>
                        <div v-if="selectedItem != 0 && !selectAllAPI">
                            <div class="mb-2">
                                <span class="font-size-15 text-yellow">{{ selectedTarget.prexC }}</span>
                                <div class="my-2 ms-3">
                                    <span class="font-size-13 text-white">{{ selectedTarget.indicatorItem }}</span>
                                    <div  class="mt-2">
                                        <b-card
                                            class="
                                                p-0
                                                shadow
                                                cursor-pointer
                                                border border-secondary
                                            "
                                            no-body
                                        >
                                            <b-card-header class="bg-secondary">
                                                <b-card-title class="mb-0 text-white">{{opcrType === 'planning' ? selectedTarget.description : selectedTarget.remarks}}</b-card-title>
                                            </b-card-header>
                                            <b-card-body class="p-0" v-if="opcrType === 'planning'">
                                                <div class="m-2 d-flex align-items-center justify-content-between">
                                                    <b class="text-pink">
                                                        {{selectedTarget.planningMainTarget.indicatorItem.indicatorItemClassification.classification}}
                                                    </b>
                                                    <a href="javascript:void(0);" :id="`quarter-selected-target-${selectedTarget.id}`">Quarterly Targets</a>
                                                    <b-popover
                                                        :target="`quarter-selected-target-${selectedTarget.id}`"
                                                        triggers="hover"
                                                        placement="right"
                                                        custom-class="quarter-target-popover"
                                                    >
                                                        <template v-slot:title
                                                            ><small>Quarterly Targets</small></template
                                                        >
                                                        <table class="table table-bordered">
                                                            <tr>
                                                                <td class="p-2 text-center">
                                                                    Cascaded Target
                                                                </td>
                                                                <td class="p-2 text-center">
                                                                    {{selectedTarget.planningMainTarget.indicatorItem.isPercentage ? `${selectedTarget.cascadedTarget}%` : selectedTarget.cascadedTarget}}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td class="p-2 text-center">
                                                                    Quarter 1
                                                                </td>
                                                                <td class="p-2 text-center">
                                                                    {{selectedTarget.planningMainTarget.indicatorItem.isPercentage ? `${selectedTarget.q1}%` : selectedTarget.q1}}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td class="p-2 text-center">
                                                                    Quarter 2
                                                                </td>
                                                                <td class="p-2 text-center">
                                                                    {{selectedTarget.planningMainTarget.indicatorItem.isPercentage ? `${selectedTarget.q2}%` : selectedTarget.q2}}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td class="p-2 text-center">
                                                                    Quarter 3
                                                                </td>
                                                                <td class="p-2 text-center">
                                                                    {{selectedTarget.planningMainTarget.indicatorItem.isPercentage ? `${selectedTarget.q3}%` : selectedTarget.q3}}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td class="p-2 text-center">
                                                                    Quarter 4
                                                                </td>
                                                                <td class="p-2 text-center">
                                                                    {{selectedTarget.planningMainTarget.indicatorItem.isPercentage ? `${selectedTarget.q4}%` : selectedTarget.q4}}
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </b-popover>
                                                </div>
                                            </b-card-body>
                                            <b-card-body class="p-0" v-else>
                                                <div class="m-2 d-flex align-items-center justify-content-between">
                                                    <b class="text-pink">
                                                        {{selectedTarget.mainTarget.indicatorItem.indicatorItemClassification.classification}}
                                                    </b>
                                                    <a href="javascript:void(0);" :id="`quarter-selected-target-${selectedTarget.id}`">Quarterly Targets</a>
                                                    <b-popover
                                                        :target="`quarter-selected-target-${selectedTarget.id}`"
                                                        triggers="hover"
                                                        placement="right"
                                                        custom-class="quarter-target-popover"
                                                    >
                                                        <template v-slot:title
                                                            ><small>Quarterly Targets</small></template
                                                        >
                                                        <table class="table table-bordered">
                                                            <tr>
                                                                <td class="p-2 text-center">
                                                                    Cascaded Target
                                                                </td>
                                                                <td class="p-2 text-center">
                                                                    {{selectedTarget.mainTarget.indicatorItem.isPercentage ? `${selectedTarget.cascadedTarget}%` : selectedTarget.cascadedTarget}}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td class="p-2 text-center">
                                                                    Quarter 1
                                                                </td>
                                                                <td class="p-2 text-center">
                                                                    {{selectedTarget.mainTarget.indicatorItem.isPercentage ? `${selectedTarget.q1}%` : selectedTarget.q1}}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td class="p-2 text-center">
                                                                    Quarter 2
                                                                </td>
                                                                <td class="p-2 text-center">
                                                                    {{selectedTarget.mainTarget.indicatorItem.isPercentage ? `${selectedTarget.q2}%` : selectedTarget.q2}}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td class="p-2 text-center">
                                                                    Quarter 3
                                                                </td>
                                                                <td class="p-2 text-center">
                                                                    {{selectedTarget.mainTarget.indicatorItem.isPercentage ? `${selectedTarget.q3}%` : selectedTarget.q3}}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td class="p-2 text-center">
                                                                    Quarter 4
                                                                </td>
                                                                <td class="p-2 text-center">
                                                                    {{selectedTarget.mainTarget.indicatorItem.isPercentage ? `${selectedTarget.q4}%` : selectedTarget.q4}}
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </b-popover>
                                                </div>
                                            </b-card-body>
                                        </b-card>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <span v-if="selectedItem > 0 && !selectAllAPI" class="position-absolute bg-body px-2 text-info border" style="left:10px;top:-8px;">Selected KPI</span>
                    </div>
                    <b-popover
                        :show.sync="showTarget"
                        :target="`selectTarget`"
                        :custom-class="`popoverOPCRClass`"
                        triggers="click"
                        placement="right"
                        id="targetRef"
                        ref="targetRef"
                    >
                        <template
                            v-slot:title
                        >
                            <div class="d-flex justify-content-between align-items-center">
                                <p class="m-0">Select Target</p>
                                <button
                                    type="button"
                                    class="btn btn-sm btn-danger"
                                    @click="closeTargetPopOver"
                                >
                                    <i class="bx bx-x"></i>
                                </button>
                            </div>
                        </template>
                        <b-row>
                            <b-col sm="12">
                                <label>Select KPI
                                    <span v-if="filteredItems.length == 0 && !loadItems">- No Data Found</span>
                                    <span
                                        class="text-danger"
                                        v-if="selectedItem == 0 && filteredItems.length > 0"
                                    >[Click on items]
                                    </span>
                                </label>
                                
                                <div class="mb-2">
                                    <input
                                        autocomplete="off"
                                        id="name"
                                        type="text"
                                        v-model="filterIndicatorItem"
                                        placeholder="Search KPI/Target..."
                                        class="form-control"
                                        @input="currentPageItem = 1"
                                    />
                                </div>
                                <div
                                    class="preloader-component ms-2"
                                    v-if="loadItems"
                                >
                                    <div class="status">
                                        <div class="spinner-chase w-20px h-20px">
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                            <div class="mb-2 scrollable-div" v-if="opcrType === 'planning'">
                                <b-tabs nav-class="nav-tabs-custom" content-class="pt-0 px-2 text-muted">
                                    <b-tab v-for="x in filteredItems" :key="x.id">
                                        <template v-slot:title>
                                            {{x.key}}
                                        </template>
                                        <div v-for="z in x.data" :key="`Z-${z.id}`" class="mt-2">
                                            <span class="font-size-15 text-yellow">{{ z.indicatorItem }}</span>
                                            <b-card
                                                class="
                                                    p-0
                                                    shadow
                                                    cursor-pointer
                                                    me-1
                                                "
                                                no-body
                                                @click="selectIndicatorItem(z)"
                                                :class="{
                                                    'border-radial-success':
                                                        selectedItem == z.id,
                                                    'border border-secondary':
                                                        selectedItem != z.id,
                                                }"
                                                @drop="onDropZone($event, z)"
                                                @dragenter.prevent
                                                @dragover.prevent
                                            >
                                                <b-card-header
                                                    :class="{
                                                        'bg-secondary':
                                                            selectedItem != z.id,
                                                        'bg-success bg-soft':
                                                            selectedItem == z.id,
                                                    }"
                                                >
                                                    <b-card-title
                                                        :class="{
                                                            'text-white':
                                                                selectedItem !=
                                                                z.id,
                                                            'text-primary':
                                                                selectedItem ==
                                                                z.id,
                                                        }"
                                                        class="mb-0"
                                                        v-if="
                                                            selectedItem != z.id &&
                                                            z.description && z.description.length > 70
                                                        "
                                                        >
                                                        {{
                                                            z.description && z.description.substring(0, 70)
                                                        }}<a
                                                            class="text-dark"
                                                            href="javascript:void(0);"
                                                            >...</a
                                                        ></b-card-title
                                                    >
                                                    <b-card-title
                                                        :class="{
                                                            'text-white':
                                                                selectedItem !=
                                                                z.id,
                                                            'text-dark':
                                                                selectedItem ==
                                                                z.id,
                                                        }"
                                                        class="mb-0"
                                                        v-else
                                                        >
                                                        {{
                                                            z.description
                                                        }}</b-card-title
                                                    >
                                                </b-card-header>
                                                <b-card-body class="p-0">
                                                    <div class="m-2 d-flex align-items-center flex-row-reverse">
                                                        <a href="javascript:void(0);" :id="`quarter-target-${z.id}`">Quarterly Targets</a>
                                                        <b-popover
                                                            :target="`quarter-target-${z.id}`"
                                                            triggers="hover"
                                                            placement="right"
                                                            custom-class="quarter-target-popover"
                                                        >
                                                            <template v-slot:title
                                                                ><small>Quarterly Targets</small></template
                                                            >
                                                            <table class="table table-bordered">
                                                                <tr>
                                                                    <td class="p-2 text-center">
                                                                        Cascaded Target
                                                                    </td>
                                                                    <td class="p-2 text-center">
                                                                        {{z.planningMainTarget.indicatorItem.isPercentage ? `${z.cascadedTarget}%` : z.cascadedTarget}}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td class="p-2 text-center">
                                                                        Quarter 1
                                                                    </td>
                                                                    <td class="p-2 text-center">
                                                                        {{z.planningMainTarget.indicatorItem.isPercentage ? `${z.q1}%` : z.q1}}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td class="p-2 text-center">
                                                                        Quarter 2
                                                                    </td>
                                                                    <td class="p-2 text-center">
                                                                        {{z.planningMainTarget.indicatorItem.isPercentage ? `${z.q2}%` : z.q2}}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td class="p-2 text-center">
                                                                        Quarter 3
                                                                    </td>
                                                                    <td class="p-2 text-center">
                                                                        {{z.planningMainTarget.indicatorItem.isPercentage ? `${z.q3}%` : z.q3}}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td class="p-2 text-center">
                                                                        Quarter 4
                                                                    </td>
                                                                    <td class="p-2 text-center">
                                                                        {{z.planningMainTarget.indicatorItem.isPercentage ? `${z.q4}%` : z.q4}}
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </b-popover>
                                                    </div>
                                                </b-card-body>
                                            </b-card>
                                        </div>
                                    </b-tab>
                                </b-tabs>
                            </div>
                            <template v-else>
                                <b-col
                                    sm="12"
                                    v-for="x in filteredItems"
                                    :key="x.id"
                                >
                                    <div class="mb-2 scrollable-div">
                                        <span class="font-size-15 text-yellow">{{ x.key }}</span>
                                        <div class="my-2 ms-3" v-for="y in x.data" :key="`Y-${y.id}`">
                                            <span class="font-size-13 text-white">{{ y.key }}</span>
                                            <div  v-for="z in y.data" :key="`Z-${z.id}`" class="mt-2">
                                            <b-card
                                                class="
                                                    p-0
                                                    shadow
                                                    cursor-pointer
                                                    me-1
                                                "
                                                no-body
                                                @click="selectIndicatorItem(z)"
                                                :class="{
                                                    'border-radial-success':
                                                        selectedItem == z.id,
                                                    'border border-secondary':
                                                        selectedItem != z.id,
                                                }"
                                                @drop="onDropZone($event, z)"
                                                @dragenter.prevent
                                                @dragover.prevent
                                            >
                                                <b-card-header
                                                    :class="{
                                                        'bg-secondary':
                                                            selectedItem != z.id,
                                                        'bg-success bg-soft':
                                                            selectedItem == z.id,
                                                    }"
                                                >
                                                    <b-card-title
                                                        :class="{
                                                            'text-white':
                                                                selectedItem !=
                                                                z.id,
                                                            'text-primary':
                                                                selectedItem ==
                                                                z.id,
                                                        }"
                                                        class="mb-0"
                                                        v-if="
                                                            selectedItem != z.id &&
                                                            z.remarks && z.remarks
                                                                .length > 70
                                                        "
                                                        >
                                                        {{
                                                            z.remarks && z.remarks.substring(
                                                                0,
                                                                70
                                                            )
                                                        }}<a
                                                            class="text-dark"
                                                            href="javascript:void(0);"
                                                            >...</a
                                                        ></b-card-title
                                                    >
                                                    <b-card-title
                                                        :class="{
                                                            'text-white':
                                                                selectedItem !=
                                                                z.id,
                                                            'text-dark':
                                                                selectedItem ==
                                                                z.id,
                                                        }"
                                                        class="mb-0"
                                                        v-else
                                                        >
                                                        {{
                                                            z.remarks
                                                        }}</b-card-title
                                                    >
                                                </b-card-header>
                                                <b-card-body class="p-0">
                                                    <div class="m-2 d-flex align-items-center justify-content-between">
                                                        <b class="text-pink">
                                                            {{z.mainTarget.indicatorItem.indicatorItemClassification.classification}}
                                                        </b>
                                                        <a href="javascript:void(0);" :id="`quarter-target-${z.id}`">Quarterly Targets</a>
                                                        <b-popover
                                                            :target="`quarter-target-${z.id}`"
                                                            triggers="hover"
                                                            placement="right"
                                                            custom-class="quarter-target-popover"
                                                        >
                                                            <template v-slot:title
                                                                ><small>Quarterly Targets</small></template
                                                            >
                                                            <table class="table table-bordered">
                                                                <tr>
                                                                    <td class="p-2 text-center">
                                                                        Cascaded Target
                                                                    </td>
                                                                    <td class="p-2 text-center">
                                                                        {{z.mainTarget.indicatorItem.isPercentage ? `${z.cascadedTarget}%` : z.cascadedTarget}}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td class="p-2 text-center">
                                                                        Quarter 1
                                                                    </td>
                                                                    <td class="p-2 text-center">
                                                                        {{z.mainTarget.indicatorItem.isPercentage ? `${z.q1}%` : z.q1}}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td class="p-2 text-center">
                                                                        Quarter 2
                                                                    </td>
                                                                    <td class="p-2 text-center">
                                                                        {{z.mainTarget.indicatorItem.isPercentage ? `${z.q2}%` : z.q2}}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td class="p-2 text-center">
                                                                        Quarter 3
                                                                    </td>
                                                                    <td class="p-2 text-center">
                                                                        {{z.mainTarget.indicatorItem.isPercentage ? `${z.q3}%` : z.q3}}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td class="p-2 text-center">
                                                                        Quarter 4
                                                                    </td>
                                                                    <td class="p-2 text-center">
                                                                        {{z.mainTarget.indicatorItem.isPercentage ? `${z.q4}%` : z.q4}}
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </b-popover>
                                                    </div>
                                                </b-card-body>
                                            </b-card>
                                            </div>
                                        </div>
                                    </div>
                                </b-col>
                                <b-col
                                    sm="12"
                                    v-if="
                                        filteredItems.length > 0 &&
                                        !loadItems
                                    "
                                >
                                    <div
                                        class="
                                            dataTables_paginate
                                            paging_simple_numbers
                                            float-end
                                        "
                                    >
                                        <ul
                                            class="
                                                pagination
                                                pagination-rounded
                                                mb-0
                                            "
                                        >
                                            <b-pagination
                                                v-model="currentPageItem"
                                                :total-rows="rowsItems"
                                                :per-page="perPageItem"
                                            ></b-pagination>
                                        </ul>
                                    </div>
                                </b-col>
                            </template>
                        </b-row>
                    </b-popover>
                </div>
                <div class="border-dashed-img position-relative p-3 text-center cursor-pointer" id="selectOPCR" @click="getAllAPI" :class="{'bg-info bg-soft info': selectAllAPI}">
                    <h5 class="text-muted mb-0"> View All API's </h5>
                </div>
            </div>
        </b-col>
        <b-col sm="9">
            <div class="card border shadow">
                <div class="card-body">
                    <div
                        class="
                            d-flex
                            justify-content-between
                            align-items-center
                        "
                    >
                        <h4 class="card-title m-0">
                            {{ apiName }} API List
                        </h4>
                        <template v-if="opcrType === 'planning'">
                            <button
                                v-if="
                                    selectedOPCR &&
                                    !selectAllAPI && 
                                    selectedItem > 0 &&
                                    !selectedTransfer.id
                                    && !startSelection
                                    && (selectedOPCR && (selectedOPCR.status.toUpperCase().includes('DRAFT') || selectedOPCR.status.toUpperCase().includes('RETURN')))
                                "
                                type="button"
                                @click="addApi(null)"
                                class="
                                    btn btn-md btn-info
                                    d-flex
                                    align-items-center
                                    no-wrap
                                "
                            >
                                <i class="bx bx-plus fs-6"></i
                                >Create New
                            </button>
                            <button
                                v-if="
                                    !department &&
                                    selectedItem == 0 &&
                                    selectAllAPI &&
                                    !selectedTransfer.id
                                    && !startSelection
                                    && (selectedOPCR && (selectedOPCR.status.toUpperCase().includes('DRAFT') || selectedOPCR.status.toUpperCase().includes('RETURN')))
                                "
                                type="button"
                                @click="showImportApis()"
                                class="
                                    btn btn-md btn-info
                                    d-flex
                                    align-items-center
                                    no-wrap
                                "
                            >
                                <i class="bx bx-download fs-6 me-1"></i
                                >Department API's
                            </button>
                        </template>
                        <template v-else>
                            <button
                                type="button"
                                @click="addApi(null)"
                                v-if="selectedOPCR && $store.state.decrypt.isAdmin() && !selectedTransfer.id && !selectAllAPI"
                                class="
                                    btn btn-md btn-info
                                    d-flex
                                    align-items-center
                                    no-wrap
                                "
                            >
                                <i
                                    class="bx bx-plus fs-6"
                                ></i
                                >Create New
                            </button>
                        </template>
                    </div>
                    <template v-if="selectAllAPI">
                        <div class="row mt-2">
                            <div class="col-md-6">
                                <div
                                    id="tickets-table_length"
                                    class="dataTables_length"
                                >
                                    <label
                                        class="
                                            d-inline-flex
                                            align-items-center
                                            mb-0
                                        "
                                    >
                                        Show&nbsp;
                                        <b-form-select
                                            class="
                                                form-select
                                                form-select-sm
                                                mx-1
                                            "
                                            v-model="perPage"
                                            size="sm"
                                            :options="
                                                pageOptions
                                            "
                                        ></b-form-select
                                        >&nbsp;entries
                                    </label>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div
                                    id="tickets-table_filter"
                                    class="
                                        dataTables_filter
                                        text-md-end
                                    "
                                >
                                    <label
                                        class="
                                            d-inline-flex
                                            align-items-center
                                        "
                                    >
                                        Search:
                                        <b-form-input
                                            autocomplete="off"
                                            v-model="filter"
                                            type="search"
                                            placeholder="Search..."
                                            class="
                                                form-control
                                                form-control-sm
                                                ms-2
                                            "
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="mt-2">
                            <template v-if="tableBusy">
                                <div class="d-flex justify-content-center align-items-center">
                                    <div class="spinner-grow text-primary" role="status">
                                        <span class="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <b-tabs nav-class="nav-tabs-custom" content-class="pt-0 px-2 text-muted">
                                    <b-tab v-for="x in filteredApis" :key="x.id">
                                        <template v-slot:title>
                                            {{x.key}}
                                        </template>
                                        <div v-for="(z, zIndex) in x.data" :key="`${x.id}Z-${zIndex}`" class="mt-2">
                                            <hr v-if="zIndex != 0" class="py-0 my-1">
                                            <div class="d-flex justify-content-between align-items-center">
                                                <div>
                                                    <span class="fs-5 text-yellow d-block text-hover cursor-pointer" @click="z.showApis = !z.showApis">{{opcrType === 'planning' ? z.planningTarget : z.target }}</span>
                                                    <small>{{determineApis(z).length}} API's</small>
                                                </div>
                                                <div v-if="opcrType === 'planning'">
                                                    <button type="button" class="btn btn-sm btn-info" @click="addApi(z)" v-if="$store.state.decrypt.isAdmin() || (!selectedTransfer.id && (selectedOPCR && (selectedOPCR.status.toUpperCase().includes('DRAFT') || selectedOPCR.status.toUpperCase().includes('RETURN'))))"><i class="bx bx-plus"></i>Create API</button>
                                                </div>
                                                <div v-if="opcrType !== 'planning' && $store.state.decrypt.isAdmin()">
                                                    <button type="button" class="btn btn-sm btn-info" @click="addApi(z)" v-if="!selectedTransfer.id"><i class="bx bx-plus"></i>Create API</button>
                                                </div>
                                            </div>
                                            <template v-if="z.showApis">
                                                <hr class="mt-1 mb-2">
                                                <h5 no-body class="mb-2">{{x.data.length ? `List of API's` : 'No data found'}}</h5>
                                                <div v-for="(w, wIndex) in filterApiCards(determineApis(z))" :key="`API-B-${w.id}`" class="ms-3">
                                                    <b-card no-body :style="{zIndex: `${x.data.length - zIndex}${determineApis(z).length - wIndex}`}" class="mb-2 shadow-none border">
                                                        <RawData v-if="$store.state.decrypt.isAdmin()" :data="w" />
                                                        <b-card-header>
                                                            <div class="d-flex justify-content-between align-items-center">
                                                                <div>
                                                                    <template v-if="!startSelection">
                                                                        <span class="d-block cursor-pointer text-hover" @click="goToPPMPAll(w, z)"><span class="text-warning">[{{w.id}}]</span>{{w.name}}
                                                                            <span v-if="w.fromModification" class="font-size-10 text-green">[From Modification]</span>
                                                                            <sup v-if="w.departmentName" class="badge bg-purple">{{w.departmentName}}</sup>
                                                                        </span>
                                                                    </template>
                                                                    <template v-else>
                                                                        <div
                                                                            class="
                                                                                form-check
                                                                                form-checkbox-outline
                                                                                form-check-success
                                                                            "
                                                                        >
                                                                            <input
                                                                                type="checkbox"
                                                                                :id="`apiSelection-${w.id}`"
                                                                                checked="checked"
                                                                                class="form-check-input"
                                                                                v-model="w.selected"
                                                                            /><label
                                                                                :for="`apiSelection-${w.id}`"
                                                                                class="form-check-label"
                                                                            >
                                                                                <b
                                                                                    class="text-white"
                                                                                    :id="`${w.id}`"
                                                                                >
                                                                                    [{{w.id}}]{{ w.name}}
                                                                                </b>
                                                                            </label>
                                                                        </div>
                                                                    </template>
                                                                    <small class="d-block" v-if="w.description">[{{w.description}}]</small>
                                                                    <small>Total: {{w.totalResources}}</small>
                                                                    <small v-if="w.isBigProject || proposal" class="d-block"><a href="javascript:void(0)" class="text-yellow" @click="showApiAttachments(w)">[Attachments]</a></small>
                                                                </div>
                                                                <b-dropdown
                                                                    id="dropdown-dropleft"
                                                                    right
                                                                    variant="link"
                                                                    toggle-class="text-decoration-none"
                                                                    menu-class="dropdown-menu-end"
                                                                    no-caret
                                                                    v-if="!selectedTransfer.id"
                                                                >
                                                                    <template #button-content><i class="fas fa-ellipsis-v"></i></template>

                                                                    <b-dropdown-item
                                                                        @click="goToPPMPAll(w, z)"
                                                                        variant="dark"
                                                                    >
                                                                        <i class="bx bx-notepad font-size-18 me-1"></i>Resources
                                                                    </b-dropdown-item>
                                                                    <template v-if="opcrType === 'planning'">
                                                                        <b-dropdown-item
                                                                            @click="printPPMPByApi(w.id, 1)"
                                                                            variant="purple"
                                                                            v-if="!department"
                                                                        >
                                                                            <i class="bx bx-printer font-size-18 me-1"></i>Generate PPMP
                                                                        </b-dropdown-item>
                                                                        <b-dropdown-item
                                                                            @click="printPPMPByApi(w.id, 2)"
                                                                            variant="purple"
                                                                            v-if="!department"
                                                                        >
                                                                            <i class="bx bx-printer font-size-18 me-1"></i>Generate PPMP (v2)
                                                                        </b-dropdown-item>
                                                                        <!-- <b-dropdown-item
                                                                            @click="printIndicativePR(w.id)"
                                                                            variant="purple"
                                                                            v-if="!department"
                                                                        >
                                                                            <i class="bx bx-printer font-size-18 me-1"></i>Generate Indicative PR
                                                                        </b-dropdown-item> -->
                                                                        <b-dropdown-item
                                                                            v-if="$store.state.decrypt.isAdmin() || ((selectedOPCR.status.toUpperCase().includes('DRAFT') || selectedOPCR.status.toUpperCase().includes('RETURN')) && !w.departmentPlanningApiId)"
                                                                            @click="updateItemAll(w, z)"
                                                                            variant="dark"
                                                                        >
                                                                            <i class="bx bx-edit font-size-18 me-1"></i>Edit</b-dropdown-item
                                                                        >
                                                                        <b-dropdown-item
                                                                            v-if="selectedOPCR.status.toUpperCase().includes('DRAFT') || selectedOPCR.status.toUpperCase().includes('RETURN') || $store.state.decrypt.isAdmin()"
                                                                            @click="deleteItemAll(w, z)"
                                                                            variant="danger"
                                                                        >
                                                                            <i class="mdi mdi-trash-can font-size-18 me-1"></i>Delete</b-dropdown-item
                                                                        >
                                                                    </template>
                                                                    <template v-else>
                                                                        <b-dropdown-item
                                                                            @click="printPPMPByApi(w.id, 1)"
                                                                            v-if="w.status && w.status.toLowerCase() === 'posted'"
                                                                            variant="purple"
                                                                        >
                                                                            <i class="bx bx-printer font-size-18 me-1"></i>Generate PPMP
                                                                        </b-dropdown-item>
                                                                        <b-dropdown-item
                                                                            @click="printPPMPByApi(w.id, 2)"
                                                                            variant="purple"
                                                                            v-if="!department"
                                                                        >
                                                                            <i class="bx bx-printer font-size-18 me-1"></i>Generate PPMP (v2)
                                                                        </b-dropdown-item>
                                                                        <b-dropdown-item
                                                                            @click="updateItemAll(w, z)"
                                                                            variant="dark"
                                                                            v-if="$store.state.decrypt.isAdmin()"
                                                                        >
                                                                            <i class="bx bx-edit font-size-18 me-1"></i>Edit
                                                                        </b-dropdown-item>
                                                                        <b-dropdown-item
                                                                            v-if="$store.state.decrypt.isAdmin()"
                                                                            @click="deleteItemAll(w, z)"
                                                                            variant="danger"
                                                                        >
                                                                            <i class="mdi mdi-trash-can font-size-18 me-1"></i>Delete</b-dropdown-item
                                                                        >
                                                                    </template>
                                                                </b-dropdown>
                                                                <div v-else class="text-center">
                                                                    <small v-if="transferApiIfs(w)"><a href="javascript:void(0);" class="text-success hoverable-link text-nowrap" @click="selectTransferApi(w, z)">Transfer Here</a></small>
                                                                    <small v-else class="text-muted">Can't transfer here</small>
                                                                </div>
                                                            </div>
                                                        </b-card-header>
                                                    </b-card>
                                                </div>
                                            </template>
                                        </div>
                                    </b-tab>
                                </b-tabs>
                            </template>
                            <hr>
                        </div>
                    </template>
                    <template v-else>
                        <div class="row mt-4">
                            <div class="col-sm-12 col-md-6 d-flex align-items-center">
                                <div
                                    class="
                                        form-check
                                        form-checkbox-outline
                                        form-check-success
                                    "
                                    v-if="targetData.length > 0 && startSelection"
                                >
                                    <input
                                        type="checkbox"
                                        :id="`apiSelectionAll`"
                                        checked="checked"
                                        class="
                                            form-check-input
                                        "
                                        v-model="checkAll"
                                    /><label
                                        :for="`apiSelectionAll`"
                                        class="
                                            form-check-label
                                        "
                                    >
                                        Select All
                                    </label>
                                </div>
                                <span v-if="targetData.length > 0 && startSelection" class="mx-2">|</span>
                                <div
                                    id="tickets-table_length"
                                    class="dataTables_length"
                                >
                                    <label
                                        class="
                                            d-inline-flex
                                            align-items-center
                                            mb-0
                                        "
                                    >
                                        Show&nbsp;
                                        <b-form-select
                                            class="
                                                form-select
                                                form-select-sm
                                                mx-1
                                            "
                                            v-model="perPage"
                                            size="sm"
                                            :options="
                                                pageOptions
                                            "
                                        ></b-form-select
                                        >&nbsp;entries
                                    </label>
                                </div>
                            </div>
                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                                <div
                                    id="tickets-table_filter"
                                    class="
                                        dataTables_filter
                                        text-md-end
                                    "
                                >
                                    <label
                                        class="
                                            d-inline-flex
                                            align-items-center
                                        "
                                    >
                                        Search:
                                        <b-form-input
                                            autocomplete="off"
                                            v-model="filter"
                                            type="search"
                                            placeholder="Search..."
                                            class="
                                                form-control
                                                form-control-sm
                                                ms-2
                                            "
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <div class="table-responsive mb-0">
                            <b-table
                                class="datatables"
                                :items="targetData"
                                :fields="returnFields"
                                responsive="sm"
                                :per-page="perPage"
                                :current-page="currentPage"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                :filter="filter"
                                :filter-included-fields="filterOn"
                                :busy="tableBusy"
                                @filtered="onFiltered"
                                bordered
                                outlined
                                hover
                                striped
                                show-empty
                            >
                                <template #empty="scope">
                                    <div class="text-center">
                                        {{ scope.emptyText }}
                                    </div>
                                </template>
                                <template #table-busy>
                                    <div class="d-flex justify-content-center align-items-center">
                                        <div class="preloader-component me-2">
                                            <div class="status">
                                                <div class="spinner-chase w-20px h-20px">
                                                    <div class="chase-dot"></div>
                                                    <div class="chase-dot"></div>
                                                    <div class="chase-dot"></div>
                                                    <div class="chase-dot"></div>
                                                    <div class="chase-dot"></div>
                                                    <div class="chase-dot"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <strong>Loading...</strong>
                                    </div>
                                </template>
                                <template #cell(name)="data">
                                    <a
                                        href="javascript:void(0);"
                                        class="d-flex justify-content-start"
                                        @click="goToPPMP(data.item)"
                                        v-if="!startSelection"
                                    >
                                        <div>
                                            <b
                                                class="text-white"
                                                :id="`${data.item.id}`"
                                            >
                                                {{ data.item.name }}
                                                
                                            </b>
                                            <small v-if="data.item.description" class="text-white d-block">{{data.item.description}}</small>
                                        </div>
                                        <div v-if="data.item.notification">
                                            <span 
                                                class="badge rounded-pill bg-danger float-end"
                                                style="font-size:8px;"
                                            >
                                                {{ data.item.notification > 0 ? data.item.notification : "" }}
                                            </span>
                                        </div>
                                    </a>
                                    <div 
                                        class="form-check form-checkbox-outline form-check-success"
                                        v-else
                                    >
                                        <input
                                            type="checkbox"
                                            :id="`apiSelection-${data.item.id}`"
                                            checked="checked"
                                            class="form-check-input"
                                            v-model="data.item.selected"
                                        /><label
                                            :for="`apiSelection-${data.item.id}`"
                                            class="form-check-label"
                                        >
                                            <b
                                                class="text-white"
                                                :id="`${data.item.id}`"
                                            >
                                                {{ data.item.name }}
                                            </b>
                                        </label>
                                    </div>
                                    <div v-if="data.item.departmentPlanningApiId">
                                        <i><small>From Department: <span class="text-warning">{{data.item.departmentName}}</span></small></i>
                                    </div>
                                </template>
                                <template #cell(status)="data">
                                    <div>
                                        <span>Status: </span>
                                        <template
                                            v-if="data.value.toUpperCase().includes('POSTED')"
                                        >
                                            <span
                                                class="
                                                    badge
                                                    bg-success
                                                    font-size-12
                                                "
                                                >{{
                                                    data.value
                                                }}</span
                                            >
                                        </template>
                                        <template
                                            v-else-if="data.value.toUpperCase().includes('APPROVE')"
                                        >
                                            <span
                                                class="
                                                    badge
                                                    bg-success
                                                    bg-soft
                                                    font-size-12
                                                "
                                                >{{
                                                    data.value
                                                }}</span
                                            >
                                        </template>
                                        <template
                                            v-else-if=" data.value.toUpperCase().includes('RETURN')"
                                        >
                                            <span
                                                class="
                                                    badge
                                                    bg-warning
                                                    bg-soft
                                                    font-size-12
                                                    text-warning
                                                "
                                                >{{
                                                    data.value
                                                }}</span
                                            >
                                        </template>
                                        <template v-else>
                                            {{ data.value }}
                                        </template>
                                    </div>
                                    <div class="mt-1">
                                        Planning:
                                        <template v-if="data.item.planningStatus">
                                            <template v-if="data.item.planningStatus.toUpperCase().includes('APPROVE')">
                                                <span class="badge bg-success bg-soft font-size-12">
                                                    {{ data.item.planningStatus }}
                                                </span>
                                            </template>
                                            <template v-else-if="data.item.planningStatus.toUpperCase().includes('RETURN')">
                                                <span class="badge bg-warning bg-soft font-size-12 text-warning">
                                                    {{ data.item.planningStatus }}
                                                </span>
                                            </template>
                                            <template v-else>
                                                {{ data.item.planningStatus }}
                                            </template>
                                        </template>
                                        <template v-else>
                                            PENDING
                                        </template>
                                    </div>
                                    <div class="mt-1">
                                        Finance:
                                        <template v-if="data.item.financeStatus">
                                            <template v-if="data.item.financeStatus.toUpperCase().includes('APPROVE')">
                                                <span class="badge bg-success bg-soft font-size-12">
                                                    {{ data.item.financeStatus }}
                                                </span>
                                            </template>
                                            <template v-else-if="data.item.financeStatus.toUpperCase().includes('RETURN')">
                                                <span class="badge bg-warning bg-soft font-size-12 text-warning">
                                                    {{ data.item.financeStatus }}
                                                </span>
                                            </template>
                                            <template v-else>
                                                {{ data.item.financeStatus }}
                                            </template>
                                        </template>
                                        <template v-else>
                                            PENDING
                                        </template>
                                    </div>
                                </template>
                                <template #cell(actions)="row">
                                    <div class="float-end" v-if="!selectedTransfer.id">
                                        <b-dropdown
                                            id="dropdown-dropleft"
                                            right
                                            variant="link"
                                            toggle-class="text-decoration-none"
                                            menu-class="dropdown-menu-end"
                                            no-caret
                                        >
                                            <template #button-content>
                                                <i class="fas fa-ellipsis-v"></i>
                                            </template>
                                            <b-dropdown-item
                                                @click="goToPPMP(row.item)"
                                                variant="dark"
                                            >
                                                <i class="bx bx-notepad font-size-18 me-1"></i>Resources
                                            </b-dropdown-item>
                                            <template v-if="opcrType === 'planning'">
                                                <b-dropdown-item
                                                    @click="printPPMPByApi(row.item.id, 1)"
                                                    variant="purple"
                                                >
                                                    <i class="bx bx-printer font-size-18 me-1"></i>Generate PPMP
                                                </b-dropdown-item>
                                                <b-dropdown-item
                                                    @click="printPPMPByApi(row.item.id, 2)"
                                                    variant="purple"
                                                >
                                                    <i class="bx bx-printer font-size-18 me-1"></i>Generate PPMP (v2)
                                                </b-dropdown-item>
                                                <!-- <b-dropdown-item
                                                    @click="printIndicativePR(row.item.id)"
                                                    variant="purple"
                                                >
                                                    <i class="bx bx-printer font-size-18 me-1"></i>Generate Indicative PR
                                                </b-dropdown-item> -->
                                                <b-dropdown-item
                                                    v-if="(selectedOPCR.status.toUpperCase().includes('DRAFT') || selectedOPCR.status.toUpperCase().includes('RETURN')) && !row.item.departmentPlanningApiId"
                                                    @click="updateItem(row)"
                                                    variant="dark"
                                                    ><i
                                                        class="
                                                            bx
                                                            bx-edit
                                                            font-size-18
                                                            me-1
                                                        "
                                                    ></i
                                                    >Edit</b-dropdown-item
                                                >
                                                <b-dropdown-item
                                                    v-if="selectedOPCR.status.toUpperCase().includes('DRAFT') || selectedOPCR.status.toUpperCase().includes('RETURN')"
                                                    @click="deleteItem(row)"
                                                    variant="danger"
                                                    ><i
                                                        class="
                                                            mdi
                                                            mdi-trash-can
                                                            font-size-18
                                                            me-1
                                                        "
                                                    ></i
                                                    >Delete</b-dropdown-item
                                                >
                                            </template>
                                            <template v-else>
                                                <b-dropdown-item
                                                    @click="updateItem(row)"
                                                    variant="dark"
                                                    v-if="$store.state.decrypt.isAdmin()"
                                                >
                                                    <i class="bx  bx-edit font-size-18 me-1"></i>Edit
                                                </b-dropdown-item>
                                                <!-- v-if="
                                                    row.item.status.toUpperCase() !== 'POSTED' &&
                                                    row.item.status.toUpperCase() !== 'APPROVED' &&
                                                    !row.item.priority && !selectedTransfer.id
                                                " -->
                                                <b-dropdown-item
                                                    @click="deleteItem(row)"
                                                    variant="danger"
                                                    v-if="row.item.status.toUpperCase() !== 'POSTED' &&
                                                        row.item.status.toUpperCase() !== 'APPROVED' &&
                                                        !row.item.priority &&
                                                        !selectedTransfer.id
                                                    "
                                                    ><i
                                                        class="
                                                            mdi
                                                            mdi-trash-can
                                                            font-size-18
                                                            me-1
                                                        "
                                                    ></i
                                                    >Delete</b-dropdown-item
                                                >
                                                <b-dropdown-item
                                                    v-if="row.item.status.toUpperCase() !== 'CREATED' && !selectedTransfer.id"
                                                    @click="viewApiLogs(row.item.id)"
                                                    variant="dark"
                                                    ><i
                                                        class="
                                                            bx bx-menu-alt-right
                                                            font-size-18
                                                            me-1
                                                        "
                                                    ></i
                                                    >View Logs</b-dropdown-item
                                                >
                                                <b-dropdown-item
                                                    @click="printPPMPByApi(row.item.id)"
                                                    variant="purple"
                                                >
                                                    <i class="bx bx-printer font-size-18 me-1"></i>Generate PPMP
                                                </b-dropdown-item>
                                                <b-dropdown-item
                                                    v-if="row.item.status.toUpperCase() !== 'POSTED' && row.item.status.toUpperCase() !== 'APPROVED' && !selectedTransfer.id"
                                                    @click="postPPMP(row.item)"
                                                    variant="success"
                                                >
                                                    <i class="bx bx-check font-size-18 me-1"></i>Post this Work</b-dropdown-item
                                                >
                                            </template>
                                        </b-dropdown>
                                    </div>
                                    <div v-else class="text-center">
                                        <small v-if="transferApiIfs(row.item)"><a href="javascript:void(0);" class="text-success hoverable-link text-nowrap" @click="selectTransferApi(row.item)">Transfer Here</a></small>
                                        <small v-else class="text-muted">Can't transfer here</small>
                                    </div>
                                </template>
                                <template #row-details="row">
                                    <transition
                                        name="max-height"
                                    >
                                        <div v-if="row.item.showAttachments">
                                            <div class="d-flex justify-content-between align-items-center">
                                                <div>
                                                    <input
                                                        type="search"
                                                        class="form-control form-control-sm"
                                                        placeholder="Search Attachments"
                                                        v-model="row.item.fileSearch"
                                                        @input="searchDocu(row.item)"
                                                    />
                                                </div>
                                                <button
                                                    type="button"
                                                    class="btn btn-outline-success no-wrap btn-sm"
                                                    :id="`api-document${row.item.id}`"
                                                    @click="row.item.addDocu = true"
                                                >
                                                    <i class="bx bx-upload  me-1"></i>
                                                    Upload Document
                                                </button>
                                                <upload-popover
                                                    :option="uploadOptions"
                                                    :sourceId="row.item.id"
                                                    @uploaded="uploadedDocument($event, row.item.id)"
                                                    :showPV="row.item.addDocu"
                                                    @closePopover="row.item.addDocu = false"
                                                    :dzId="`dropzone-api${row.item.id}`"
                                                    :pvId="`api-document${row.item.id}`"
                                                ></upload-popover>
                                            </div>
                                            <div
                                                class="
                                                    d-flex
                                                    justify-content-center
                                                    align-items-center
                                                "
                                                v-if="
                                                    row.item
                                                        .attachmentLoading
                                                "
                                            >
                                                <div
                                                    class="
                                                        preloader-component
                                                        me-2
                                                    "
                                                >
                                                    <div
                                                        class="
                                                            status
                                                        "
                                                    >
                                                        <div
                                                            class="
                                                                spinner-chase
                                                                w-20px
                                                                h-20px
                                                            "
                                                        >
                                                            <div
                                                                class="
                                                                    chase-dot
                                                                "
                                                            ></div>
                                                            <div
                                                                class="
                                                                    chase-dot
                                                                "
                                                            ></div>
                                                            <div
                                                                class="
                                                                    chase-dot
                                                                "
                                                            ></div>
                                                            <div
                                                                class="
                                                                    chase-dot
                                                                "
                                                            ></div>
                                                            <div
                                                                class="
                                                                    chase-dot
                                                                "
                                                            ></div>
                                                            <div
                                                                class="
                                                                    chase-dot
                                                                "
                                                            ></div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <strong
                                                    >Loading...</strong
                                                >
                                            </div>
                                            <div
                                                class="row"
                                                v-if="
                                                    !row.item
                                                        .attachmentLoading
                                                "
                                            >
                                                <div
                                                    class="
                                                        col-md-4
                                                        mb-2
                                                    "
                                                    v-for="(
                                                        y, index
                                                    ) in searchDocu(
                                                        row.item
                                                    )"
                                                    :key="y.id"
                                                >
                                                    <div
                                                        class="
                                                            position-relative
                                                            cursor-pointer
                                                            border
                                                            mt-2
                                                            border-secondary
                                                            br-5
                                                        "
                                                        :style="`z-index: ${
                                                            searchDocu(
                                                                row.item
                                                            )
                                                                .length -
                                                            index
                                                        }`"
                                                    >
                                                        <div
                                                            class="
                                                                border
                                                                p-3
                                                            "
                                                        >
                                                            <div>
                                                                <div
                                                                    class="
                                                                        float-end
                                                                        ms-2
                                                                    "
                                                                >
                                                                    <b-dropdown
                                                                        id="dropdown-dropleft"
                                                                        right
                                                                        variant="link"
                                                                        toggle-class="text-decoration-none text-dark font-size-16 pt-0"
                                                                        menu-class="dropdown-menu-end"
                                                                        no-caret
                                                                    >
                                                                        <template
                                                                            #button-content
                                                                        >
                                                                            <i
                                                                                class="
                                                                                    mdi
                                                                                    mdi-dots-horizontal
                                                                                "
                                                                            ></i>
                                                                        </template>
                                                                        <b-dropdown-item
                                                                            @click="
                                                                                openDocument(
                                                                                    y
                                                                                )
                                                                            "
                                                                            ><i
                                                                                class="
                                                                                    bx
                                                                                    bx-link-external
                                                                                    me-1
                                                                                "
                                                                            ></i
                                                                            >Open</b-dropdown-item
                                                                        >
                                                                        <b-dropdown-item
                                                                            variant="danger"
                                                                            @click="
                                                                                removeFile(
                                                                                    y.id,
                                                                                    row
                                                                                        .item
                                                                                        .id
                                                                                )
                                                                            "
                                                                            ><i
                                                                                class="
                                                                                    bx
                                                                                    bx-trash
                                                                                    me-1
                                                                                "
                                                                            ></i
                                                                            >Remove</b-dropdown-item
                                                                        >
                                                                    </b-dropdown>
                                                                </div>
                                                                <div
                                                                    class="
                                                                        avatar-xs
                                                                        me-3
                                                                        mb-2
                                                                    "
                                                                    @click="
                                                                        openDocument(
                                                                            y
                                                                        )
                                                                    "
                                                                >
                                                                    <div
                                                                        class="
                                                                            avatar-title
                                                                            bg-transparent
                                                                            rounded
                                                                        "
                                                                    >
                                                                        <i
                                                                            v-if="
                                                                                y.fileType.includes(
                                                                                    'image'
                                                                                )
                                                                            "
                                                                            class="
                                                                                mdi
                                                                                mdi-image
                                                                                font-size-24
                                                                                text-purple
                                                                            "
                                                                        ></i>
                                                                        <i
                                                                            v-if="
                                                                                y.fileType.includes(
                                                                                    'application'
                                                                                )
                                                                            "
                                                                            class="
                                                                                mdi
                                                                                mdi-file-pdf-outline
                                                                                font-size-24
                                                                                text-danger
                                                                            "
                                                                        ></i>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="
                                                                        d-flex
                                                                    "
                                                                    @click="
                                                                        openDocument(
                                                                            y
                                                                        )
                                                                    "
                                                                >
                                                                    <div
                                                                        class="
                                                                            overflow-hidden
                                                                            me-auto
                                                                        "
                                                                    >
                                                                        <h5
                                                                            class="
                                                                                font-size-14
                                                                                text-truncate
                                                                                mb-1
                                                                            "
                                                                        >
                                                                            {{
                                                                                y.description
                                                                            }}
                                                                        </h5>
                                                                        <p
                                                                            class="
                                                                                text-muted
                                                                                mb-0
                                                                            "
                                                                        >
                                                                            {{
                                                                                formatDateWithTime(
                                                                                    new Date(
                                                                                        y.dateTimeUploaded
                                                                                    )
                                                                                )
                                                                            }}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    class="
                                                        col-md-12
                                                        text-center
                                                        mt-2
                                                    "
                                                    v-if="
                                                        searchDocu(
                                                            row.item
                                                        )
                                                            .length ==
                                                            0 &&
                                                        row.item
                                                            .attachments
                                                            .length >
                                                            0
                                                    "
                                                >
                                                    Search Not
                                                    Found
                                                </div>
                                                <div
                                                    class="
                                                        col-md-12
                                                        text-center
                                                        mt-2
                                                    "
                                                    v-if="
                                                        row.item
                                                            .attachments
                                                            .length ==
                                                        0
                                                    "
                                                >
                                                    No Document
                                                    Found
                                                </div>
                                            </div>
                                        </div>
                                    </transition>
                                </template>
                            </b-table>
                        </div>
                    </template>
                    <div class="row">
                        <template v-if="opcrType === 'planning'">
                            <div class="col" v-if="!selectAllAPI && selectedOPCR && targetData.length && selectedOPCR.status.toUpperCase() === 'DRAFT'">
                                <div class="d-flex align-items-center">
                                    <button type="button" class="btn btn-link" :class="{'text-warning': startSelection}" @click="openSelectionOfApi">
                                        <span v-if="!startSelection" class="d-flex align-items-center"><i class="bx bx-repost"></i>Transfer API to another Target</span>
                                        <span v-else class="d-flex align-items-center"><i class="bx bx-x"></i>Cancel Transfer</span>
                                    </button>
                                    <div class="d-flex align-items-center" v-if="startSelection">
                                        <span class="me-2">[ {{selectedApiComputed.length}} selected ]</span>
                                        <button type="button" class="btn btn-success btn-sm" v-if="selectedApiComputed.length > 0" @click="transferApiToKPI"><i class="bx bx-check"></i> Transfer Now</button>
                                    </div>
                                </div>
                            </div>
                            <div class="col" v-if="selectAllAPI && selectedOPCR && $store.state.decrypt.isAdmin() && !tableBusy">
                                <div class="d-flex align-items-center">
                                    <button type="button" class="btn btn-link" :class="{'text-warning': startSelection}" @click="openSelectionOfApi">
                                        <span v-if="!startSelection" class="d-flex align-items-center"><i class="bx bx-repost"></i>Transfer API to another {{nameSelection}}</span>
                                        <span v-else class="d-flex align-items-center"><i class="bx bx-x"></i>Cancel Transfer</span>
                                    </button>
                                    <div class="d-flex align-items-center" v-if="startSelection">
                                        <span class="me-2">[ {{selectedApiComputed.length}} selected ]</span>
                                        <button type="button" class="btn btn-success btn-sm" v-if="selectedApiComputed.length > 0" @click="transferApiToOPCR"><i class="bx bx-check"></i> Transfer Now</button>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <div class="col" v-if="!selectAllAPI">
                            <div
                                class="
                                    dataTables_paginate
                                    paging_simple_numbers
                                    float-end
                                "
                            >
                                <ul
                                    class="
                                        pagination
                                        pagination-rounded
                                        mb-0
                                    "
                                >
                                    <!-- pagination -->
                                    <b-pagination
                                        v-model="
                                            currentPage
                                        "
                                        :total-rows="rows"
                                        :per-page="perPage"
                                    ></b-pagination>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-col>
    </b-row>
</template>